import register from './register.vue'

export default register


